﻿import React, { useState, useEffect } from 'react';
import { GetPendingPoliciesByNPN } from '../../../api/policies';
import { useQuery } from '@tanstack/react-query';
import LoadingIndicator from '../../../components/Global/loading-indicator/loading-indicator';

import { DataGrid } from '@mui/x-data-grid';

export default function PendingPoliciesDataGrid({ ...props }) {
  const [columns, setColumns] = useState([]);
  const [rowData, setRowData] = useState([]);

  const getPendingPoliciesByNPN = useQuery({
    queryKey: ['GetPendingPoliciesByNPN', props.policyStatus, props.searchText],
    queryFn: () =>
      GetPendingPoliciesByNPN([
        { queryParam: 'policyStatus', queryVal: props.policyStatus },
        { queryParam: 'searchText', queryVal: props.searchText },
      ])(),
    enabled: props.policyStatus !== undefined && props.policyStatus !== null,
  });

  useEffect(() => {
    if (getPendingPoliciesByNPN.isSuccess && getPendingPoliciesByNPN.data) {
      const data = getPendingPoliciesByNPN.data;
      var columnsArray = [
        { field: 'policyNumber', headerName: 'Policy Number', flex: 1.5, align: 'left' },
        {
          field: 'appReceivedDate',
          headerName: 'App Received Date',
          valueFormatter: (value) => {
            const date = new Date(value);
            return date.toLocaleDateString();
          },
          flex: 1.5,
          align: 'left',
        },
        { field: 'pendingStatus', headerName: 'Status', flex: 1.25, align: 'left' },
        { field: 'distributor', headerName: 'Distributor', flex: 2, align: 'left' },
        { field: 'agent', headerName: 'Agent', flex: 2, align: 'left' },
        { field: 'npn', headerName: 'NPN', flex: 1, align: 'left' },
        { field: 'policyOwner', headerName: 'Policy Owner', flex: 2, align: 'left' },
        { field: 'product', headerName: 'Product', flex: 2, align: 'left' },
        {
          field: 'estimatedPremium',
          headerName: 'Estimated Premium',
          flex: 1.75,
          align: 'right',
          valueFormatter: (value) => {
            return new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2,
            }).format(value);
          },
        },
      ];

      setColumns(columnsArray);

      props.setPolicyData(data);
      props.setColumns(columnsArray);

      var rData = data?.map((cl, index) => ({
        id: `row-${index}`,
        policyNumber: cl.policyNumber,
        appReceivedDate: cl.appReceivedDate,
        pendingStatus: cl.pendingStatus,
        distributor: cl.distributor,
        agent: cl.agent,
        npn: cl.npn,
        policyOwner: cl.policyOwner,
        product: cl.product,
        estimatedPremium: cl.estimatedPremium,
        policyStatus: cl.policyStatus,
        rowIndex: index,
      }));

      setRowData(rData);
    }
  }, [getPendingPoliciesByNPN.isSuccess, getPendingPoliciesByNPN.data]);

  if (getPendingPoliciesByNPN.isPending || getPendingPoliciesByNPN.isFetching)
    return <LoadingIndicator />;

  if (getPendingPoliciesByNPN.isError || rowData === undefined || rowData === null)
    return (
      <div style={{ width: '100%', fontSize: '2em', textAlign: 'center', margin: '2em 0' }}>
        No Data to Display
      </div>
    );

  return (
    <div style={{ height: 500, width: '100%' }}>
      {
        <DataGrid
          sx={{
            '& .MuiDataGrid-row:hover': {
              backgroundColor: 'transparent',
            },
            '& .MuiDataGrid-row.Mui-hovered': {
              backgroundColor: 'transparent',
            },
            '& p': {
              margin: 0,
            },
            '& .MuiTablePagination-actions': {
              marginTop: 0,
            },
          }}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          rows={rowData}
          columns={columns}
          loading={getPendingPoliciesByNPN.isPending || getPendingPoliciesByNPN.isFetching}
        />
      }
    </div>
  );
}
